import { HydratedChatbot } from "@zapier/client";
import { EmptyChatbotsTableTypes } from "./EmptyChatbotsTable";

interface UseShowEmptyChatbotsTableProps {
  chatbots: HydratedChatbot[];
  isLoading: boolean;
  isFiltered?: boolean;
  shared?: string | null;
}

export function useShowEmptyChatbotsTable({
  chatbots,
  isLoading,
  isFiltered = false,
  shared,
}: UseShowEmptyChatbotsTableProps) {
  if (isLoading) {
    return {
      showEmptyState: false,
      emptyType: undefined,
    };
  }

  if (chatbots.length === 0) {
    if (isFiltered) {
      return {
        showEmptyState: true,
        emptyType: EmptyChatbotsTableTypes.EmptySearchResults,
      };
    }

    if (!isFiltered && !isLoading && shared === "-me") {
      return {
        showEmptyState: true,
        emptyType: EmptyChatbotsTableTypes.NoSharedChatbots,
      };
    }

    if (!isFiltered && !isLoading && shared === "me") {
      return {
        showEmptyState: true,
        emptyType: EmptyChatbotsTableTypes.NoOwnedChatbots,
      };
    }

    return {
      showEmptyState: true,
      emptyType: EmptyChatbotsTableTypes.NoChatbots,
    };
  }

  return {
    showEmptyState: false,
    emptyType: undefined,
  };
}
